module.exports = __webpack_public_path__ + "static/media/netlify.cb7dfe7d.png";